var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToolTipIcon = function SvgToolTipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "tool-tip-icon_svg__c",
    width: 14,
    height: 14,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tool-tip-icon_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tool-tip-icon_svg__d",
    width: 2,
    height: 8,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tool-tip-icon_svg__b"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "tool-tip-icon_svg__a",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "tool-tip-icon_svg__b",
    d: "M6 11V6h2v5zm0-6V3h2v2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#666",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tool-tip-icon_svg__a",
    mask: "url(#tool-tip-icon_svg__c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tool-tip-icon_svg__b",
    fill: "#FFF",
    mask: "url(#tool-tip-icon_svg__d)"
  }))));
};
export default SvgToolTipIcon;